// src/components/WhatsAppButton.jsx
import React from 'react';
import './whatsappbutton.css'; // Import custom styles for the WhatsApp button

const WhatsAppButton = () => {
  return (
    <a
      href="https://wa.me/+918740074320" // Replace with your WhatsApp Business number
      className="whatsapp-button"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img src="/assets/whatsappicon.png" alt="WhatsApp" className="whatsapp-logo" />
    </a>
  );
};

export default WhatsAppButton;
